import BooksLineDetailPage, {
  booksLineDetailQuery,
} from "@app/pages/books/books-line-detail-page";
import type { booksLineDetailPage_Query } from "@app/queries/booksLineDetailPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/books_/$code")({
  loader: ({ params }) =>
    loadQuery<booksLineDetailPage_Query>(
      environment,
      booksLineDetailQuery,
      { code: params.code },
      { fetchPolicy: "network-only" }
    ),
  head: ({ params }) => pageHead(`Books ${params.code}`),
  component: BooksLineDetailRoute,
});

function BooksLineDetailRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={<div className="p-6 text-red-500">Error loading the line</div>}
    >
      <Suspense fallback={<div className="p-6 text-gray-500">Loading...</div>}>
        <BooksLineDetailPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
